import React from "react";
import { isEmpty, startCase } from "lodash";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import TableHeaderCell from "components/reusable/TableHeaderCell";

const Table = ({ registeredCompanies, page, sort, setSort }) => {
  const { t } = useTranslation();

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE]  bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <TableHeaderCell text={t("SR_NO")} />
              <TableHeaderCell text={t("COMPANY_ID")} />
              <TableHeaderCell text={t("COMPANY_NAME")} />
              <TableHeaderCell text={t("OFFICIAL_EMAIL_ID")} />
              <TableHeaderCell text={t("COMPANY_NUMBER")} />
              <TableHeaderCell text={t("O_COUNTRY")} />
              <TableHeaderCell text={t("O_CITY")} />
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("CREATED_DATE")}</span>
                  <span>
                    {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>

              <th scope="col" className="py-3 px-6 text-center">
                {t("O_STATUS")}
              </th>
            </tr>
          </thead>
          <tbody>
            {registeredCompanies &&
              registeredCompanies?.map((item, i) => (
                <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-4 px-6 border-r text-gray-900">{item?._id}</td>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.name}</td>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.officialEmail}</td>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.companyNumber}</td>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.Country?.name}</td>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.City?.name}</td>
                  <td className="py-4 px-6 border-r text-gray-900 ">{dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")}</td>
                  <td className="py-4 px-6 border-r text-gray-900 text-center">{startCase(item?.status)}</td>
                </tr>
              ))}
            {isEmpty(registeredCompanies) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={10}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
